import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';

import {
  LinkTitle,
  LinkDescription,
  LinkDetailsWrapper,
  LinkDetailsControls,
  LinkDetailsUrl,
  StyledButton,
  StyledLink,
} from './LinkDetails.styles';

interface LinkDetailsProps {
  title?: string;
  description?: string;
  url: string;
  previewUrl?: string;
  singleLine?: boolean;
}

export const LinkDetails: React.FC<LinkDetailsProps> = ({
  title,
  description,
  url,
  previewUrl,
  singleLine = false,
}) => {
  const dispatch = useDispatch();
  const copyUrl = useCallback(() => {
    if (navigator?.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          dispatch(
            toastsActions.positive({
              headline: 'Copied to clipboard',
            })
          );
        })
        .catch(() => {
          dispatch(
            toastsActions.negative({
              headline: `Couldn't copy to clipboard`,
            })
          );
        });
    }
  }, [dispatch, url]);

  return (
    <LinkDetailsWrapper>
      {!!title && <LinkTitle>{title}</LinkTitle>}
      {!!description && <LinkDescription>{description}</LinkDescription>}
      <LinkDetailsControls singleLine={singleLine}>
        <LinkDetailsUrl fullWidth={!singleLine}>{url}</LinkDetailsUrl>
        <StyledButton onClick={copyUrl} size="small">
          Copy
        </StyledButton>
        <StyledLink
          variant="secondary"
          component="a"
          href={previewUrl || url}
          size="small"
          target="_blank"
        >
          Preview
        </StyledLink>
      </LinkDetailsControls>
    </LinkDetailsWrapper>
  );
};
